var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input-number',_vm._g(_vm._b({ref:"inputNumber",attrs:{"controls-position":_vm.$attrs.controlsPosition || _vm.$attrs['controls-position'] || 'right',"controls":_vm.controls}},'el-input-number',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }